import api from './../../lib/api';

export const LLM_TOOLS_LOAD = 'LLM_TOOLS_LOAD';
export const LLM_TOOL_ADD = 'LLM_TOOL_ADD';
export const LLM_TOOL_UPDATE = 'LLM_TOOL_UPDATE';
export const LLM_TOOL_DELETE = 'LLM_TOOL_DELETE';

const LLM_TOOLS_LOADING_CHANGE = 'LLM_TOOLS_LOADING_CHANGE';
const LLM_TOOLS_CHANGE = 'LLM_TOOLS_CHANGE';
const LLM_TOOLS_ERRORS_CHANGE = 'LLM_TOOLS_ERRORS_CHANGE';
const LLM_TOOLS_SAVING_CHANGE = 'LLM_TOOLS_SAVING_CHANGE';
const LLM_TOOL_CHANGE = 'LLM_TOOL_CHANGE';
const LLM_TOOL_DELETE_CHANGE = 'LLM_TOOL_DELETE_CHANGE';

const state = {
  tools: [],
  tools_loading: false,
  tools_saving: false,
  tools_errors: {},
};

const actions = {
  /**
   * Загружает список инструментов роли ассистента
   * @param commit
   * @param state
   * @param {Object} param
   * @param {string} param.assistantId - ID ассистента (UUID)
   * @param {string} param.roleName - Имя роли (guide/moderator)
   */
  [LLM_TOOLS_LOAD]({ commit, state }, param) {
    const assistantId = param.assistantId;
    const roleName = param.roleName;

    if (!assistantId || !roleName) {
      commit(LLM_TOOLS_CHANGE, { tools: [] });
      return Promise.resolve(false);
    }

    return api.load(
      'assistant.tools.list',
      [assistantId, roleName],
      state,
      commit,
      LLM_TOOLS_LOADING_CHANGE,
      LLM_TOOLS_CHANGE,
      LLM_TOOLS_ERRORS_CHANGE,
    );
  },

  /**
   * Добавляет новый инструмент (скил) в роль ассистента
   * @param commit
   * @param state
   * @param {Object} param
   * @param {string} param.assistantId
   * @param {string} param.roleName
   * @param {string} param.toolName
   * @param {string|null} param.defaultModel
   */
  [LLM_TOOL_ADD]({ commit, state }, param) {
    const assistantId = param.assistantId;
    const roleName = param.roleName;
    const toolName = param.toolName;
    const defaultModel = param.defaultModel || null;

    const payload = {
      tool_name: toolName,
      default_model: defaultModel,
    };

    return api.create(
      'assistant.tools.create',
      [assistantId, roleName],
      payload,
      state,
      commit,
      LLM_TOOLS_SAVING_CHANGE,
      LLM_TOOL_CHANGE,
      LLM_TOOLS_ERRORS_CHANGE,
    );
  },

  /**
   * Обновляет конфигурацию инструмента (default_model) в роли ассистента
   * @param commit
   * @param state
   * @param {Object} param
   * @param {string} param.assistantId
   * @param {string} param.roleName
   * @param {string} param.toolName
   * @param {string|null} param.defaultModel
   */
  [LLM_TOOL_UPDATE]({ commit, state }, param) {
    const assistantId = param.assistantId;
    const roleName = param.roleName;
    const toolName = param.toolName;
    const defaultModel = param.defaultModel || null;

    const payload = {
      default_model: defaultModel,
    };

    return api.update(
      'assistant.tool.update',
      [assistantId, roleName, toolName],
      payload,
      state,
      commit,
      LLM_TOOLS_SAVING_CHANGE,
      LLM_TOOL_CHANGE,
      LLM_TOOLS_ERRORS_CHANGE,
    );
  },

  /**
   * Удаляет инструмент из роли ассистента
   * @param commit
   * @param state
   * @param {Object} param
   * @param {string} param.assistantId
   * @param {string} param.roleName
   * @param {string} param.toolName
   */
  [LLM_TOOL_DELETE]({ commit, state }, param) {
    const assistantId = param.assistantId;
    const roleName = param.roleName;
    const toolName = param.toolName;

    commit(LLM_TOOLS_SAVING_CHANGE, true);

    return api
      .delete(
        'assistant.tool.delete',
        [assistantId, roleName, toolName],
        state,
        commit,
        LLM_TOOL_DELETE_CHANGE,
      )
      .finally(() => {
        commit(LLM_TOOLS_SAVING_CHANGE, false);
      });
  },
};

const mutations = {
  [LLM_TOOLS_LOADING_CHANGE](state, data) {
    state.tools_loading = !!data;
  },

  [LLM_TOOLS_SAVING_CHANGE](state, data) {
    state.tools_saving = !!data;
  },

  [LLM_TOOLS_CHANGE](state, data) {
    const tools = data && Array.isArray(data.tools) ? data.tools : [];
    state.tools = tools;
  },

  [LLM_TOOLS_ERRORS_CHANGE](state, data) {
    state.tools_errors = data || {};
  },

  /**
   * Обновляет/добавляет инструмент в локальном списке по имени
   * Используется как после создания, так и после обновления инструмента
   */
  [LLM_TOOL_CHANGE](state, data) {
    if (!data || !data.name) {
      return;
    }

    const tools = Array.isArray(state.tools) ? [...state.tools] : [];
    const index = tools.findIndex((t) => t && t.name === data.name);

    if (index === -1) {
      tools.push(data);
    } else {
      tools.splice(index, 1, data);
    }

    state.tools = tools;
  },

  /**
   * Удаляет инструмент из локального списка по имени
   * В параметре приходит массив [assistantId, roleName, toolName]
   */
  [LLM_TOOL_DELETE_CHANGE](state, id) {
    const toolName = Array.isArray(id) ? id[2] : id;

    if (!toolName || !Array.isArray(state.tools)) {
      return;
    }

    state.tools = state.tools.filter((t) => t && t.name !== toolName);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};


